import React from 'react'
import Navbar from '../Navbar/Navbar'
import Poster from '../Poster/Poster'
import Slider from '../Slider/Slider'
import Know from '../Know/Know'
import Featured from '../Featured/Featured'
import Serve from '../Serve/Serve'
import Footer from '../Footer/Footer'
import OfferPost from '../Offer-post/Offer-post'
import Count from '../Count/Count'
import Testimonials from '../Testimonials/Testimonials'
import Why from '../Why/Why'

const Home = () => {
  return (
    <>
    
       <Poster/>
      <Slider/>
      <Know/>
      <Featured/>
      <Serve/>
      <OfferPost/>
      <Count/>
      <Testimonials/>
      <Why/>
      
       
    </>
  )
}

export default Home